import AxiosInstance from "service/axiosInstance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useToast } from "hooks";

const KEY = "faqs";

const getAll = () => AxiosInstance({ method: "GET", url: "api/v1/faq" });
const create = (data) => AxiosInstance({ method: "POST", url: "api/v1/faq", data });
const update = ({ id, ...data }) => AxiosInstance({ method: "PATCH", url: `api/v1/faq/${id}`, data });
const toggleVisibility = (id) => AxiosInstance({ method: "PATCH", url: `api/v1/faq/${id}/toggle-visibility` });
const remove = (id) => AxiosInstance({ method: "DELETE", url: `api/v1/faq/${id}` });

export const useGetFaqs = () =>
  useQuery({ queryKey: [KEY], queryFn: getAll, staleTime: 0 });

export const useCreateFaq = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(create, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("FAQ created"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

export const useUpdateFaq = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(update, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("FAQ updated"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

export const useToggleFaq = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(toggleVisibility, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("Visibility updated"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

export const useDeleteFaq = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(remove, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("FAQ deleted"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};
